import Header from "@/pages/home/components/Header";
import Hero from "@/pages/home/components/Hero";
import Archive from "@/pages/home/components/Archive";
import Relation from "@/pages/home/components/Relation";
import Background from "@/pages/home/components/Background";
import Discussion from "@/pages/home/components/Discussion";
import Faq from "@/pages/home/components/Faq";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Header />
      <main className="flex-1">
        <Hero />
        <Archive />
        <Relation />
        <Background />
        <Discussion />
        <Faq />
      </main>
      <Footer />
    </div>
  );
}